<template>
  <!-- 文章分类 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
    <!-- <el-tooltip placement="top">
      <template #content>选择相应[文章分类]数据动态更新PC端[栏目列表]页</template>
      <el-button type="primary" size="large" @click="releaseFnc($event)"
        ><el-icon><Position /></el-icon>发布</el-button
      >
    </el-tooltip> -->
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="ArticleClassification"
    @update-list="updateList"
    excelName="文章分类"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
    @handleSelection="handleSelection"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
  </TableList>
  <!-- 添加编辑 文章分类 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="640px"
     draggable
            destroy-on-close
  >
    <AddEditArticleClass
      v-if="addEditVisible"
      :edit-id="editId"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditArticleClass>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import { reactive, onMounted, toRefs, ref, toRaw,h,computed, nextTick} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import AddEditArticleClass from "views/articleClassification/AddEditArticleClass.vue";
import store from "../../store/index";
import {
  getCategoryPag,
  removeCategory,
  PublishCategoryHtml,
} from "network/articleClassification.js";

export default {
  name: "ArticleClassification",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    AddEditArticleClass,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        }, {
          label: "分类名称",
          prop: "name",
          minwidth: "220",
          align: "left",
          noSetText: "未设置",
          fixed: "left",
        },
        {
          label: "TDK标题",
          prop: "title",
          width: "300",
          align: "center",
          noSetText: "未设置",
        },
        {
          label: "TDK关键字",
          prop: "keywords",
          minwidth: "300",
          align: "center",
          noSetText: "未设置",
          isTagArr: true,
        },
        {
          label: "TDK描述",
          prop: "desp",
          minwidth: "300",
          align: "center",
          noSetText: "未设置",
        },
      ],
      dialogTitle: "添加文章分类",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //是否是编辑
      multipleSelection: [], //选中行数据
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      getClassData(""); //文章来源
    });

    // 获取列表
    const getClassData = () => {
      data.loading = true;
      getCategoryPag()
        .then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            const list = result.result;
            const dataList = toRaw(list);
            data.tableData = dataList;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    //更新列表
    const updateList = () => {
      getClassData();
    };

    // 添加/
    const addFnc = () => {
      data.addEditVisible = true;
      data.dialogTitle = "添加文章分类";
      data.editId = 0;
    };

    // 编辑
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${data.multipleSelection[0].name}】分类`;
      data.editId = data.multipleSelection[0].id;
    };

    // 删除
    const deleteFnc = (obj) => {
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${data.multipleSelection[0].name}`
          ),
          h("span", null, "】分类？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            removeCategory(data.multipleSelection[0].id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      removeCategory(id)
        .then((result) => {
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };
    // 表格多选行处理
    const handleSelection = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    //发布
    const releaseFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (data.multipleSelection == 0) {
        ElMessage.error("请选择需要发布的数据");
        return;
      }
     if (data.multipleSelection.length > 1) {
        ElMessage.error("只能选择一个进行发布");
        return;
      }
      ElMessageBox.confirm(
        `是否将[${data.multipleSelection[0].name}]发布到PC端`,
        "发布",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          postHtml(data.multipleSelection[0].id);
        })
        .catch(() => {
          ElMessage("取消发布");
        });
    };
    const postHtml = async (id) => {
      data.loading = true;
      const result = await PublishCategoryHtml(id);
      if (result.code == 1) {
        data.loading = false;
        ElMessageBox.alert(result.message, {
          confirmButtonText: "确定",
        });
        updateList();
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message, {
          confirmButtonText: "确定",
        });
      }
    };
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "right",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getClassData,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      handleSelection,
      releaseFnc,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>


